/* tslint:disable */
/* eslint-disable */
/**
 * SENGO Platform Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.27
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EventStatsRecord } from '../model';
// @ts-ignore
import type { EventStatus } from '../model';
// @ts-ignore
import type { ExportUserEventsResponse } from '../model';
// @ts-ignore
import type { NoShowCheckInsFilter } from '../model';
// @ts-ignore
import type { PaymentStatsRecord } from '../model';
// @ts-ignore
import type { UserStatsRecord } from '../model';
/**
 * ExportApi - axios parameter creator
 */
export const ExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export stats data about events
         * @param {string} [from] Starting date (included) for exported data
         * @param {string} [to] Ending date (included) for exported data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEvents: async (from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/export/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export stats data about payments
         * @param {string} [from] Starting date (included) for exported data
         * @param {string} [to] Ending date (included) for exported data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPayments: async (from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/export/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export events a user has created
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of events
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUserEventsCreated: async (userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, noShowCheckIns?: Array<NoShowCheckInsFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('exportUserEventsCreated', 'userId', userId)
            const localVarPath = `/admin/export/user/{userId}/events/created`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (noShowCheckIns) {
                localVarQueryParameter['noShowCheckIns'] = noShowCheckIns;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export events a user has participated in
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of events
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUserEventsReserved: async (userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, noShowCheckIns?: Array<NoShowCheckInsFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('exportUserEventsReserved', 'userId', userId)
            const localVarPath = `/admin/export/user/{userId}/events/reserved`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (noShowCheckIns) {
                localVarQueryParameter['noShowCheckIns'] = noShowCheckIns;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export stats data about users
         * @param {string} [from] Starting date (included) for exported data
         * @param {string} [to] Ending date (included) for exported data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUsers: async (from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/export/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportApi - functional programming interface
 */
export const ExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export stats data about events
         * @param {string} [from] Starting date (included) for exported data
         * @param {string} [to] Ending date (included) for exported data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEvents(from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventStatsRecord>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportEvents(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export stats data about payments
         * @param {string} [from] Starting date (included) for exported data
         * @param {string} [to] Ending date (included) for exported data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPayments(from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentStatsRecord>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPayments(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export events a user has created
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of events
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportUserEventsCreated(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportUserEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportUserEventsCreated(userId, startDate, endDate, status, noShowCheckIns, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportUserEventsCreated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export events a user has participated in
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of events
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportUserEventsReserved(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportUserEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportUserEventsReserved(userId, startDate, endDate, status, noShowCheckIns, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportUserEventsReserved']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export stats data about users
         * @param {string} [from] Starting date (included) for exported data
         * @param {string} [to] Ending date (included) for exported data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportUsers(from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserStatsRecord>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportUsers(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExportApi - factory interface
 */
export const ExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportApiFp(configuration)
    return {
        /**
         * 
         * @summary Export stats data about events
         * @param {string} [from] Starting date (included) for exported data
         * @param {string} [to] Ending date (included) for exported data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEvents(from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventStatsRecord>> {
            return localVarFp.exportEvents(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export stats data about payments
         * @param {string} [from] Starting date (included) for exported data
         * @param {string} [to] Ending date (included) for exported data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPayments(from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentStatsRecord>> {
            return localVarFp.exportPayments(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export events a user has created
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of events
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUserEventsCreated(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): AxiosPromise<ExportUserEventsResponse> {
            return localVarFp.exportUserEventsCreated(userId, startDate, endDate, status, noShowCheckIns, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export events a user has participated in
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of events
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUserEventsReserved(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): AxiosPromise<ExportUserEventsResponse> {
            return localVarFp.exportUserEventsReserved(userId, startDate, endDate, status, noShowCheckIns, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export stats data about users
         * @param {string} [from] Starting date (included) for exported data
         * @param {string} [to] Ending date (included) for exported data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUsers(from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserStatsRecord>> {
            return localVarFp.exportUsers(from, to, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportApi - interface
 */
export interface ExportApiInterface {
    /**
     * 
     * @summary Export stats data about events
     * @param {string} [from] Starting date (included) for exported data
     * @param {string} [to] Ending date (included) for exported data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportEvents(from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventStatsRecord>>;

    /**
     * 
     * @summary Export stats data about payments
     * @param {string} [from] Starting date (included) for exported data
     * @param {string} [to] Ending date (included) for exported data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportPayments(from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentStatsRecord>>;

    /**
     * 
     * @summary Export events a user has created
     * @param {string} userId 
     * @param {string} [startDate] Starting date (included) to search for birthday of the users
     * @param {string} [endDate] Ending date (included) to search for user birthday
     * @param {Array<EventStatus>} [status] List of status to filter the search of events
     * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUserEventsCreated(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): AxiosPromise<ExportUserEventsResponse>;

    /**
     * 
     * @summary Export events a user has participated in
     * @param {string} userId 
     * @param {string} [startDate] Starting date (included) to search for birthday of the users
     * @param {string} [endDate] Ending date (included) to search for user birthday
     * @param {Array<EventStatus>} [status] List of status to filter the search of events
     * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUserEventsReserved(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): AxiosPromise<ExportUserEventsResponse>;

    /**
     * 
     * @summary Export stats data about users
     * @param {string} [from] Starting date (included) for exported data
     * @param {string} [to] Ending date (included) for exported data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUsers(from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserStatsRecord>>;

}

/**
 * ExportApi - object-oriented interface
 */
export class ExportApi extends BaseAPI implements ExportApiInterface {
    /**
     * 
     * @summary Export stats data about events
     * @param {string} [from] Starting date (included) for exported data
     * @param {string} [to] Ending date (included) for exported data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportEvents(from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportEvents(from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export stats data about payments
     * @param {string} [from] Starting date (included) for exported data
     * @param {string} [to] Ending date (included) for exported data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportPayments(from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportPayments(from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export events a user has created
     * @param {string} userId 
     * @param {string} [startDate] Starting date (included) to search for birthday of the users
     * @param {string} [endDate] Ending date (included) to search for user birthday
     * @param {Array<EventStatus>} [status] List of status to filter the search of events
     * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportUserEventsCreated(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportUserEventsCreated(userId, startDate, endDate, status, noShowCheckIns, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export events a user has participated in
     * @param {string} userId 
     * @param {string} [startDate] Starting date (included) to search for birthday of the users
     * @param {string} [endDate] Ending date (included) to search for user birthday
     * @param {Array<EventStatus>} [status] List of status to filter the search of events
     * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportUserEventsReserved(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportUserEventsReserved(userId, startDate, endDate, status, noShowCheckIns, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export stats data about users
     * @param {string} [from] Starting date (included) for exported data
     * @param {string} [to] Ending date (included) for exported data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportUsers(from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportUsers(from, to, options).then((request) => request(this.axios, this.basePath));
    }
}

